module.exports = __webpack_public_path__ + "img/btn_menu.03d70e74.svg";